const SvgOther1 = (props) => (
  <>
    <circle cx={24} cy={24} r={24} fill={props.p40} />
    <circle cx={72} cy={72} r={24} fill={props.p40} />
  </>
);

export default SvgOther1;
